export const defaultTasks = [
  {
    id: Math.random(),

    taskName: "Think Of Action Plan",
    estimatedTaskTime: 10 * 60,

    remainingTime: parseInt(10) * 60,
    complitionTime: 0,

    isTaskRunning: true,
    isCompleted: false,
    isTaskOverdue: false,
    snoozeTimer: 0,
    taskScore: 0,
  },
  {
    id: Math.random(),

    taskName: "Set Tasks",
    estimatedTaskTime: 5 * 60,

    remainingTime: parseInt(5) * 60,
    complitionTime: 0,

    isTaskRunning: false,
    isCompleted: false,
    isTaskOverdue: false,
    snoozeTimer: 0,
    taskScore: 0,
  },
];

export const levels = [
  {
    name: "Virtuoso",
    criteria: {
      minActiveCount: 480 * 60, // in seconds more than 8 hour
      // maxOverduePercentage: 50, // in %
      minScore: 100, // optional
    },
  },
  {
    name: "Achiever",
    criteria: {
      minActiveCount: 300 * 60, // in seconds 5hour
      // maxOverduePercentage: 50, // in %
      minScore: 50,
    },
  },
  {
    name: "Elite",
    criteria: {
      minActiveCount: 180 * 60, // in seconds 3 hour
      // maxOverduePercentage: 50, // in %
      minScore: 25,
    },
  },
  {
    name: "Classic",
    criteria: {
      minActiveCount: 30 * 60, // in seconds
      // maxOverduePercentage: 10, // in %
      minScore: 10,
    },
  },
  {
    // name: ".•. Classic .•.",
    name: "Rookie",
    criteria: {}, // No specific criteria, default fallback
  },
];
